function NorfolkIsland({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1808)">
  <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5068 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5068 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#F0F0F0"/>
  <path d="M9.0435 1.58789C3.69156 4.17576 0 9.65632 0 15.9997C0 22.3431 3.69156 27.8236 9.0435 30.4115V1.58789Z" fill="#6DA544"/>
  <path d="M22.9565 1.58789V30.4115C28.3085 27.8236 32 22.343 32 15.9997C32 9.65639 28.3085 4.17576 22.9565 1.58789Z" fill="#6DA544"/>
  <path d="M20.1739 20.8697L16 7.65234L11.826 20.8697H14.9565V24.348H17.0435V20.8697H20.1739Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default NorfolkIsland;
